import { render } from "./DataTable.vue?vue&type=template&id=4b12cbee&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=4b12cbee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b12cbee"],['__file',"src/views/PartnerManagement/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b12cbee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b12cbee', __exports__)) {
    api.reload('4b12cbee', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=4b12cbee&scoped=true", () => {
    api.rerender('4b12cbee', render)
  })

}


export default __exports__